import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DataGrid, {
    Column,
    Sorting,
    Selection,
    HeaderFilter,
    Button as GridButton,
    Editing
} from 'devextreme-react/data-grid';
import {
    Paper,
    Typography,
    IconButton,
    Grid,
    FormControl,
    Input,
    FormHelperText,
    Button,
    Select,
    MenuItem,
    TextField
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarOutlined';
import {
    deleteAppMessage,
    createAppMessage,
    updateAppMessage,
    setConfirmationModalState,
} from 'store/actions';

const AppMessagesTab = ({
    classes,
    deleteAppMessage,
    createAppMessage,
    updateAppMessage,
    appMessages,
    appMessageColors,
    setConfirmationModalState,
}) => {
    // ToDo: this should be taken from state.adminState.appMessageColors[0]
    const [color, setColor] = React.useState('#faa307');
    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);
    const [body, setBody] = useState('');
    const handleColorChange = (event) => {
        setColor(event.target.value);
    };

    const onTitleChange = (e) => {
        if (!e.target.value?.length) {
            setTitleError("Title cannot be empty");
        } else if (titleError) {
            setTitleError(null);
        }
        setTitle(e?.target?.value ?? "");
    }
    const onBodyChange = (e) => {
        setBody(e?.target?.value ?? "");
    }

    const onPushClick = () => {
       
        setConfirmationModalState({ // Open confirmation modal
            isModalOpen: true,
            handleConfirmation: () => {
                console.log("Push button clicked. title = " + title + " body = " + body + " color = " + color);
                createAppMessage({
                    Subject: title,
                    Body: body,
                    Color: color,
                    IsVisible: true
                });
                setBody('');
                setTitle('');
                closeConfirmationModal();
            },
            handleCancellation: closeConfirmationModal,
            contentText: `Create new message visible to all users?`
        });
    }

    const closeConfirmationModal = () => {
        setConfirmationModalState({ isModalOpen: false });
    }

    const onDeleteClick = (e) => {
        setConfirmationModalState({ // Open confirmation modal
            isModalOpen: true,
            handleConfirmation: () => {
                console.log(`Deleting message with id = ${e.row.data.id}`);
                deleteAppMessage(e.row.data.id);
                closeConfirmationModal();
            },
            handleCancellation: closeConfirmationModal,
            contentText: `Do you want to delete current message?`
        });
    }
    
    const IsMainColumnTemplate = (cellData) => {
            console.log("Rendering IsMain column = " + cellData);
            if(!cellData.data.isMain)
            {
                return (
                    <IconButton aria-label="setAsMain" size="medium" onClick={() => changeMainMessage(cellData.data)} color={'primary'}>
                        <StarOutlineIcon/>
                    </IconButton>
                );
            }
            return ( <IconButton aria-label="main" disabled={true} size="medium" style={{color: "gold"}}>
            <StarIcon/>
        </IconButton>);
    }


    const ColorColumnTemplate = (cell) => {
        return (
            <div style={{
                background: cell.value,
                height: '1em',
                borderRadius: '10px',
                textAlign: 'center'
            }} />
        );
    }

    const changeMainMessage = (data) => {
        if (data == null) {
            console.error("Can't change main, because selected row is null");
            return;
        }
        const payload = {
            id: data.id,
            isMain: true,
        }

        setConfirmationModalState({ 
            isModalOpen: true,
            handleConfirmation: () => {
                console.log(`Change main message id = ${data.id}`);
                updateAppMessage(payload);
                closeConfirmationModal();
            },
            handleCancellation: closeConfirmationModal,
            contentText: `Set this message as main?`
        });
    }

    return (
        <div id="appMessagesGridContainer">
            <Paper className={classes.gridContainer}>
                <Typography variant="h6">Active Messages</Typography>
                <DataGrid dataSource={appMessages}
                    allowColumnResizing={true}
                    showBorders={true}
                    width="100%">
                    <Sorting mode="none" />
                    <HeaderFilter visible={false} />
                    <Editing
                        mode="row"
                        useIcons={true}
                        allowDeleting={true} >
                    </Editing>
                    <Selection
                        mode="single" />
                    <Column dataField="subject" dataType="string" caption="Title" width={150} />
                    <Column dataField="body" dataType="string" />
                    <Column dataField="color" dataType="string" cellRender={ColorColumnTemplate} width={90} />
                    <Column dataField="createdOn" dataType="date" width={100} />
                    <Column dataField="user.fullName" dataType="string" caption="UserName" width={120} />
                    <Column caption="Main Message"
                        cellRender={IsMainColumnTemplate}  width={130} alignment="center"/>
                    <Column dataField="delete" type="buttons" caption="" width={80} >
                        <GridButton name="delete" onClick={(e) => { onDeleteClick(e); }} />
                    </Column>
                </DataGrid>
                <br />
                <Typography variant="h6">New Message</Typography>
                <div
                    className={classes.newMessageGrid}>
                    <Grid
                        container
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="space-between"
                        spacing={2}>
                        <Grid item xs={3}>
                            <FormControl className={classes.formControl}>
                                <FormHelperText id="title-helper-text">Title*</FormHelperText>
                                <TextField
                                    id="title-input"
                                    error={titleError} //display helper text when title is an empty string
                                    helperText={titleError}
                                    aria-describedby="title-helper-text"
                                    placeholder="Enter a title..."
                                    required={true}
                                    value={title}
                                    onChange={onTitleChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={5}>
                            <FormControl className={classes.formControl}>
                                <FormHelperText id="body-helper-text">Body</FormHelperText>
                                <Input id="body-input"
                                    value={body}
                                    onChange={onBodyChange}
                                    aria-describedby="body-helper-text"
                                    placeholder="Enter a description..." />
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            <FormControl className={classes.formControl}>
                                <FormHelperText id="color-helper-text">Color</FormHelperText>
                                <Select labelId="color-helper-text"
                                    id="color-select"
                                    value={color}
                                    displayEmpty
                                    onChange={handleColorChange}>
                                    {appMessageColors.map((item, index) =>

                                        <MenuItem key={index} value={item.value}>
                                            <div style={{
                                                backgroundColor: item.value,
                                                color: 'white',
                                                height: '15px',
                                                width: '100%',
                                                borderRadius: '10px'
                                            }} />
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            <FormControl className={classes.formControl}>
                                <Button
                                    className={classes.btnWrap}
                                    disabled={titleError != null || !title.length}
                                    onClick={onPushClick}
                                    variant="outlined"
                                    color="primary">
                                    Publish
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        </div>
    );
};

const styles = {
    gridContainer: {
        padding: '30px',
    },
    newMessageGrid: {
        border: "1px solid lightgrey",
        padding: "10px 10px 15px 10px",
        maxWidth: 800
    },
    formControl: {
        width: '100%'
    },
    btnWrap: {
        marginTop: '20px'
    }
};

const mapStateToProps = (state) => ({
    appMessages: state.adminState.appMessages,
    appMessageColors: state.adminState.appMessageColors
});

const mapDispatchToProps = (dispatch) => ({
    deleteAppMessage: id => dispatch(deleteAppMessage(id)),
    createAppMessage: payload => dispatch(createAppMessage(payload)),
    updateAppMessage: payload => dispatch(updateAppMessage(payload)),
    setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState)),
});

export default compose(
    withRouter,
    withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(AppMessagesTab);